module.exports = __webpack_public_path__ + "static/media/loading-dots.7852e2d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/loading-dots.svg
// module id = 780
// module chunks = 0